// extracted by mini-css-extract-plugin
module.exports = {"sec":"AcceptInvite_sec__EZW8D","open":"AcceptInvite_open__EsHNN","container":"AcceptInvite_container__CMS51","text":"AcceptInvite_text__qrfA5"};